import React from "react";
import { Target, Users, Repeat } from "lucide-react";
import { SectionHeading, Reveal } from "./ui";

const models = [
  { label: "Defined SOW", headline: "Own the milestone", description: "A scoped engineering team, named deliverables, governance and measurable acceptance criteria.", icon: Target },
  { label: "Specialist augmentation", headline: "Add the judgment you are missing", description: "Domain-screened engineers integrated into your tools, cadence and technical leadership.", icon: Users },
  { label: "Build–Operate–Transfer", headline: "Build a durable capability", description: "Launch and stabilize an engineering team, then transfer it against an agreed operating plan.", icon: Repeat },
];

export default function HowWeEngage() {
  return (
    <section id="how-we-engage" className="on-dark noise section relative scroll-mt-20 overflow-hidden bg-navy-900 text-white">
      <div className="glow-blue absolute -left-40 top-1/3 h-[36rem] w-[36rem] opacity-30" aria-hidden="true" />
      <div className="container-x relative">
        <SectionHeading index="04" eyebrow="How we engage" title="Built around the engineering milestone." dark>
          You do not need more resumes. You need engineers who have done the work—with the domain fit,
          delivery structure and ownership the program needs.
        </SectionHeading>

        <div className="grid border-y border-white/10 md:grid-cols-3">
          {models.map((m, i) => (
            <Reveal key={m.label} delay={i * 100}>
              <article className="group relative h-full border-white/10 p-8 transition-colors duration-300 hover:bg-white/[0.035] md:p-10 md:[&:not(:first-child)]:border-l">
                <div className="flex items-center justify-between">
                  <m.icon className="h-7 w-7 text-brand-light" strokeWidth={1.4} aria-hidden="true" />
                  <span className="font-display text-6xl font-semibold tracking-tighter text-white/[0.07] transition-colors group-hover:text-brand-light/30">0{i + 1}</span>
                </div>
                <p className="mt-12 font-mono text-[11px] uppercase tracking-[0.22em] text-brand-light">{m.label}</p>
                <h3 className="mt-4 font-display text-2xl font-semibold leading-tight tracking-tight md:text-3xl">{m.headline}</h3>
                <p className="mt-4 leading-relaxed text-slate-300">{m.description}</p>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
